/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Why a billing period is not fully projected onto an entitlement.
 */
export type EntitlementProjectionFailure = typeof EntitlementProjectionFailure[keyof typeof EntitlementProjectionFailure];


export const EntitlementProjectionFailure = {
  overlap_conflict: 'overlap_conflict',
  expired_before_sync: 'expired_before_sync',
  linked_overlap: 'linked_overlap',
} as const;
